/**
 * NBA roll-up rows key players by core id (`nba:<nbaId>`, R2) while team
 * reports, Blitz and old bookmarks use the bare NBA integer. The player
 * endpoint matches either `player_id` or the external id, and the bare NBA id
 * is the one form both tables answer to (the DEV tables still key `player_id`
 * by SS uuid), so URLs and requests use it.
 *
 * A core id can't be a relative link as-is: React Router treats `nba:123` as an
 * absolute URL with scheme `nba:` and navigates the document to it.
 */
import type { PlayerStatsGarden } from "../../../models/PlayerStats";

const NBA_PREFIX = "nba:";

/** `"nba:1642270"` → `"1642270"`; anything else unchanged. */
export function toNbaPlayerId(id: string): string {
  return id.startsWith(NBA_PREFIX) ? id.slice(NBA_PREFIX.length) : id;
}

/** The path segment a league-table row links to: the NBA integer on the NBA garden. */
export function playerRouteSegment(
  garden: PlayerStatsGarden,
  playerId: string,
): string {
  const segment = garden === "nba" ? toNbaPlayerId(playerId) : playerId;
  // Any other id with a colon would also parse as a URL scheme.
  return segment.includes(":") ? `./${segment}` : segment;
}

/** The id the player endpoint is asked for, from a route segment (either form). */
export function playerIdFromRoute(
  garden: PlayerStatsGarden,
  segment: string | undefined,
): string | undefined {
  if (!segment) return segment;
  return garden === "nba" ? toNbaPlayerId(segment) : segment;
}
